/**
 * Maps the English display names of STANDARD work-container fields (Work Order / Task
 * built-in fields) to their translated labels. Custom / org-defined fields are not in
 * this map and fall through to their raw backend name (org data is not translated).
 *
 * Used for display labels only — never for the form field `name`/`slug`, which must
 * stay the backend value for submission.
 */
export const translateStandardFieldName = (
  name: string,
  t: (key: string, defaultValue?: string) => string
): string => {
  const map: Record<string, string> = {
    Name: t('table.name', 'Name'),
    Description: t('table.description', 'Description'),
    Status: t('table.status', 'Status'),
    'Task Type': t('table.taskType', 'Task Type'),
    Collaborators: t('workOrder.collaborators', 'Collaborators'),
    Vendor: t('table.vendor', 'Vendor'),
    'Due Date': t('table.dueDate', 'Due Date'),
    Tags: t('table.tags', 'Tags'),
    Hours: t('table.hours', 'Hours'),
    'Hours (est.)': t('table.hoursEstimated', 'Hours (est.)'),
    'Cost (est.)': t('table.costEstimated', 'Cost (est.)'),
    'Salesforce ID': t('table.salesforceId', 'Salesforce ID'),
    'Planned Start': t('table.plannedStart', 'Planned Start'),
    Created: t('table.created', 'Created'),
  };
  return map[name] ?? name;
};
